import React, { useState } from "react";
import { slide as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";
import "../styles/BurgerMenu.css";
import { FaList, FaWrench, FaSignOutAlt } from "react-icons/fa";
import WaterMeterIcon from "../components/WaterMeterIcon";

const BurgerMenu = ({ onLogout }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleLogout = () => {
    closeMenu();
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <Menu
      left
      isOpen={menuOpen}
      onStateChange={({ isOpen }) => setMenuOpen(isOpen)}
      className="bg-primary text-white"
      menuClassName="bg-primary text-white"
      burgerButtonClassName="bm-burger-button"
      burgerBarClassName="bm-burger-bars"
      crossButtonClassName="bm-cross-button"
      crossClassName="bm-cross"
      position="absolute"
    >
      <div className="pt-0">
        <Link id="works" className="menu-item" to="/works" onClick={closeMenu}>
          <span className="menu-icon">
            <FaWrench />
          </span>
          <span className="menu-text">Veemõõtja tööd</span>
        </Link>

        <Link
          id="add1"
          className="menu-item"
          to="/add1"
          onClick={() => {
            localStorage.removeItem("addData");
            closeMenu();
          }}
        >
          <span className="menu-icon">
            <WaterMeterIcon type="add" />
          </span>
          <span className="menu-text">Veemõõtja paigaldamine</span>
        </Link>

        <Link
          id="replace1"
          className="menu-item"
          to="/replace1"
          onClick={() => {
            localStorage.removeItem("replaceData");
            closeMenu();
          }}
        >
          <span className="menu-icon">
            <WaterMeterIcon type="replace" />
          </span>
          <span className="menu-text">Veemõõtja vahetus</span>
        </Link>

        <Link
          id="remove1"
          className="menu-item"
          to="/remove1"
          onClick={() => {
            localStorage.removeItem("removeData");
            closeMenu();
          }}
        >
          <span className="menu-icon">
            <WaterMeterIcon type="remove" />
          </span>
          <span className="menu-text">Veemõõtja eemaldamine</span>
        </Link>

        <Link id="lists" className="menu-item" to="/lists" onClick={closeMenu}>
          <span className="menu-icon">
            <FaList />
          </span>
          <span className="menu-text">Nimekirjade haldus</span>
        </Link>

        {/* Logout button at the bottom */}
        {onLogout && (
          <>
            <div className="menu-separator"></div>
            <button
              id="logout"
              className="menu-item logout-item"
              onClick={handleLogout}
            >
              <span className="menu-icon">
                <FaSignOutAlt />
              </span>
              <span className="menu-text">Logi välja</span>
            </button>
          </>
        )}
      </div>
    </Menu>
  );
};

export default BurgerMenu;
